import { render, staticRenderFns } from "./show_plateform.vue?vue&type=template&id=68d86413&"
import script from "./show_plateform.vue?vue&type=script&lang=js&"
export * from "./show_plateform.vue?vue&type=script&lang=js&"
import style0 from "./show_plateform.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports